(function () {
    'use strict';

    angular
        .module('app')
        .controller('ItemCopySummaryDialogCtrl', ItemCopySummaryDialogCtrl);

    ItemCopySummaryDialogCtrl.$inject = ['DialogInstance', 'ItemService', 'itemCopyState', 'preCopyConfirmMode'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for summary of Item copying.
     *
     * @param {array} itemCopyState
     * @param {bool} preCopyConfirmMode - True if the dialog should present the items as
     *   "The following will be copied, continue?" prompt. False if summarising the results
     *   of a copy operation.
     */
    function ItemCopySummaryDialogCtrl(DialogInstance, ItemService, itemCopyState, preCopyConfirmMode) {
        /* jshint validthis:true */
        var vm = this;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.itemsToCopy = [];
        vm.copiedItems = [];
        vm.itemsNotCopyable = [];
        vm.itemsWithError = [];
        vm.preCopyConfirmMode = preCopyConfirmMode;
        vm.itemsToCopyCount = 0;
        vm.copiedItemsCount = 0;
        vm.itemsNotCopyableCount = 0;
        vm.itemsWithErrorCount = 0;

        activate();

        function activate() {
            var itemsToCopy = _.chain(itemCopyState).filter({ status: ItemService.itemCopyStatuses.ToBeCopied }).map('item').value();
            var copiedItems = _.chain(itemCopyState).filter({ status: ItemService.itemCopyStatuses.Copied }).map('item').value();
            var itemsNotCopyable = _.chain(itemCopyState).filter({ status: ItemService.itemCopyStatuses.ItemTypeCannotBeCopied }).map('item').value();
            var itemsWithError = _.chain(itemCopyState).filter({ status: ItemService.itemCopyStatuses.Error }).map('item').value();

            vm.itemsToCopy = ItemService.summariseItemList(itemsToCopy);
            vm.copiedItems = ItemService.summariseItemList(copiedItems);
            vm.itemsNotCopyable = ItemService.summariseItemList(itemsNotCopyable);
            vm.itemsWithError = ItemService.summariseItemList(itemsWithError);

            vm.itemsToCopyCount = itemsToCopy.length;
            vm.copiedItemsCount = copiedItems.length;
            vm.itemsNotCopyableCount = itemsNotCopyable.length;
            vm.itemsWithErrorCount = itemsWithError.length;
        }

        function ok() {
            DialogInstance.ok();
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
